import React from 'react'
import TextField from '@mui/material/TextField'

export interface ICalendarDayComment {
  comment: string
}

interface IProps {
  comment: string
  firstDay: moment.Moment
  width: number
  height: number
  isEditing: boolean
  fontSize: string
  onChange?(value: string): void
}

const DayComment: React.FC<IProps> = ({
  comment,
  firstDay,
  width,
  height,
  isEditing,
  fontSize,
  onChange,
}) => {
  const [newComment, setNewComment] = React.useState<string>(comment ?? '')
  const maxLength = 50

  React.useEffect(() => {
    setNewComment(comment ?? '')
  }, [comment, firstDay])

  return (
    <div
      className="weekCalendar__headerColumn"
      style={{
        width,
        verticalAlign: 'top',
      }}
    >
      {isEditing ? (
        <TextField
          sx={{
            '& .MuiInputBase-root': {
              height,
            },
            input: { textAlign: 'center' },
          }}
          value={newComment}
          variant="standard"
          multiline
          maxRows={3}
          inputProps={{
            maxLength,
            style: { textAlign: 'center' },
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            onChange(event.target.value)
            setNewComment(event.target.value)
          }}
        />
      ) : (
        <div
          lang="sv"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            wordWrap: 'break-word',
            fontWeight: 'normal',
            height: '100%',
            wordBreak: 'break-word',
            fontSize,
            hyphens: 'auto',
          }}
        >
          {comment}
        </div>
      )}
    </div>
  )
}

export default DayComment
